//import { receiveServerErrors } from '../errors/error_actions';
import Cookies from "js-cookie";

export const REQUEST_CAMPAIGN = "REQUEST_CAMPAIGN";
export const RECEIVE_CAMPAIGN = "RECEIVE_CAMPAIGN";
export const ADD_CAMPAIGN = "ADD_CAMPAIGN";
export const RECEIVE_ADDED_CAMPAIGN = "RECEIVE_ADDED_CAMPAIGN";
export const FAILURE_ADDED_CAMPAIGN = "FAILURE_ADDED_CAMPAIGN";
export const SEND_EMAIL = "SEND_EMAIL";
export const RECEIVE_RESPONSE = "RECEIVE_RESPONSE";
export const RECEIVE_INFLUENCERS_CAMPAIGN = "RECEIVE_INFLUENCERS_CAMPAIGN";
export const RESET_RESPONSE = "RESET_RESPONSE";

export const requestCampaign = () => ({ type: REQUEST_CAMPAIGN });

export const receiveCampaign = (campaign) => ({
  type: RECEIVE_CAMPAIGN,
  campaign,
});

export const addCampaign = () => ({ type: ADD_CAMPAIGN });

export const addCampaignFailure = () => ({ type: FAILURE_ADDED_CAMPAIGN });

export const receiveAddedCampaign = (data) => ({
  type: RECEIVE_ADDED_CAMPAIGN,
  data,
});

export const sendEmail = () => ({ type: SEND_EMAIL });

export const receiveResponse = (response) => ({
  type: RECEIVE_RESPONSE,
  response,
});

export const resetResponse = () => ({
  type: RESET_RESPONSE,
});

export const receiveInfluencersCampaign = (influencersCampaign) => ({
  type: RECEIVE_INFLUENCERS_CAMPAIGN,
  influencersCampaign,
});

export const fetchCampaign = (id) => (dispatch) => {
  dispatch(requestCampaign());
  $.ajax({
    method: "get",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/mail_campaigns`,
    // url: 'api/mail_campaigns',
    data: {
      ...{ brand_manager_id: id },
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(campaign) {
      dispatch(receiveCampaign(campaign));
    },
    error(xhr) {
      //dispatch(receiveServerErrors(xhr));
    },
  });
};

export const createCampaign = (data) => (dispatch) => {
  dispatch(addCampaign());
  $.ajax({
    method: "post",
    //url: 'api/mail_campaigns',
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/mail_campaigns`,
    data: {
      ...data,
      user_id: Cookies.get("uId"),
    },
    success(campaign) {
      dispatch(receiveAddedCampaign(campaign));
    },
    error(xhr) {
      dispatch(addCampaignFailure());
      //dispatch(receiveServerErrors(xhr));
    },
  });
};

export const sendMail = (mailParams) => (dispatch) => {
  dispatch(sendEmail());
  $.ajax({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/jwt_api/mail_campaigns/send_mail`,
    //url: 'api/mail_campaigns/send_mail',
    data: {
      ...mailParams,
      brand_id: Cookies.get("bId"),
      user_id: Cookies.get("uId"),
    },
    success(response) {
      dispatch(receiveResponse(response));
    },
    error(xhr) {
      //dispatch(receiveServerErrors(xhr));
    },
  });
};
